import { createFileRoute } from "@tanstack/react-router";
import { renderSetOpsTestCaseIntoCanvas } from "geom/polyclip/render";
import type { SetOpsTestCase } from "geom/polyclip/test/setOpsTestCaseType";
import { SetOpsTestCases } from "geom/polyclip/test/testCasesSetOps";
import styles from "lib/components/debug/polyclip.module.scss";
import { useCallback, useState } from "react";
import Canvas from "./-Canvas";

function SetOpsTest() {
  const [query, setQuery] = useState("");
  const [renderInput, setRenderInput] = useState(true);
  const [renderResult, setRenderResult] = useState(true);
  const [renderSnapRoundResult, setRenderSnapRoundResult] = useState(true);
  const [renderPolygonClippingResult, setRenderPolygonClippingResult] = useState(true);

  return (
    <div className={styles.polyclip}>
      <div
        style={{
          top: 0,
          right: 0,
          zIndex: 3,
          background: "white",
          padding: 4,
          margin: 10,
          position: "fixed",
          overflowY: "scroll",
          overflowX: "hidden",
          boxShadow: "0 0 16px rgba(0,0,0,0.4)",
        }}
      >
        <div style={{ paddingBottom: 5, display: "flex", flexDirection: "row", alignItems: "center" }}>
          <label>Search</label>
          <input
            style={{ marginLeft: 4, width: "100%", boxSizing: "border-box" }}
            type="text"
            value={query}
            onChange={(x) => setQuery(x.target.value.toLowerCase())}
          />
        </div>
        <table>
          <thead>
            <tr>
              <td></td>
              <td>Source</td>
              <td>Color</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <input type="checkbox" checked={renderInput} onChange={() => setRenderInput(!renderInput)} />
              </td>
              <td>Input</td>
              <td>Multiple</td>
            </tr>
            <tr>
              <td>
                <input type="checkbox" checked={renderResult} onChange={() => setRenderResult(!renderResult)} />
              </td>
              <td>Result</td>
              <td style={{ color: "red" }}>red</td>
            </tr>
            <tr>
              <td>
                <input
                  type="checkbox"
                  checked={renderSnapRoundResult}
                  onChange={() => setRenderSnapRoundResult(!renderSnapRoundResult)}
                />
              </td>
              <td>Result (Snap Round)</td>
              <td style={{ color: "blue" }}>blue</td>
            </tr>
            <tr>
              <td>
                <input
                  type="checkbox"
                  checked={renderPolygonClippingResult}
                  onChange={() => setRenderPolygonClippingResult(!renderPolygonClippingResult)}
                />
              </td>
              <td>polygon-clipping</td>
              <td style={{ color: "green" }}>green</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        style={{
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 2,
          margin: 4,
          padding: 4,
          position: "fixed",
          overflowY: "scroll",
          overflowX: "hidden",
          background: "white",
        }}
      >
        <div
          style={{
            display: "flex",
            fontWeight: "bold",
            flexWrap: "wrap",
            fontSize: 12,
          }}
        >
          {SetOpsTestCases.filter((x) => !query || x.name.toLowerCase().includes(query)).map((x, i) => {
            return (
              <div key={i} style={{ padding: 10 }}>
                <SetOpsTestCaseCanvas
                  test={x}
                  renderInput={renderInput}
                  renderResult={renderResult}
                  renderSnapRoundResult={renderSnapRoundResult}
                  renderPolygonClippingResult={renderPolygonClippingResult}
                />
                <div style={{ maxWidth: 240 }}>{x.name}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export function SetOpsTestCaseCanvas({
  test,
  renderInput,
  renderResult,
  renderSnapRoundResult,
  renderPolygonClippingResult,
}: {
  test: SetOpsTestCase;
  renderInput: boolean;
  renderResult: boolean;
  renderSnapRoundResult: boolean;
  renderPolygonClippingResult: boolean;
}) {
  const renderTest = useCallback(
    (canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D, viewerScale: number) => {
      renderSetOpsTestCaseIntoCanvas(
        canvas,
        ctx,
        test,
        viewerScale,
        renderInput,
        renderResult,
        renderSnapRoundResult,
        renderPolygonClippingResult,
      );
    },
    [test, renderInput, renderResult, renderSnapRoundResult, renderPolygonClippingResult],
  );

  const [expanded, setExpanded] = useState(false);

  const canvasWidth = test.canvasWidth ?? 240;
  const canvasHeight = test.canvasHeight ?? 240;

  return (
    <>
      <Canvas
        canvasWidth={expanded ? 800 : canvasWidth}
        canvasHeight={expanded ? 800 : canvasHeight}
        render={renderTest}
      />
      <button onClick={() => setExpanded(!expanded)}>{!expanded ? "Expand" : "Collapse"}</button>
    </>
  );
}

export const Route = createFileRoute("/debug/polyclip/set-ops-test")({
  component: SetOpsTest,
});
